/**
 * Jump-Navigation für .section--bannertext (nur wenn [data-bannertext-jumplinks] existiert).
 */
export function bannertextJumplinks() {
	const nav = document.querySelector('[data-bannertext-jumplinks]')
	if (!nav) {
		return
	}

	const sections = document.querySelectorAll('section.section--jumplinks[id]')
	nav.textContent = ''

	if (!sections.length) {
		nav.hidden = true
		return
	}

	sections.forEach((section) => {
		const heading = section.querySelector('.heading')
		if (!heading) {
			return
		}

		const label = heading.textContent.trim()
		if (!label) {
			return
		}

		const li = document.createElement('li')
		const link = document.createElement('a')
		link.href = `#${section.id}`

		const icon = section.querySelector('figure.icon i')
		if (icon) {
			link.appendChild(icon.cloneNode(true))
			link.append(' ')
		}

		link.append(label)
		li.append(link)
		nav.append(li)
	})

	nav.hidden = nav.children.length === 0
}
